import { RentManagerProperty, Tenant } from "../data/models.interface"

export const formatDate = (date?: string) => {
	if (date == null) return ""
	date = date.substring(0, 10)
	if (date <= "2000-01-01") return ""
	if (date >= "2999-12-31") return ""
	return date
}

/** Return searchable names of supported lease properties without substituting the resident's account property. */
export const formatTenantLeaseProperties = (tenant: Tenant, properties: RentManagerProperty[]): string => {
	const leasePropertyIds = new Set(tenant.Leases.map((lease) => lease.Unit?.PropertyID))
	return properties
		.filter((property) => leasePropertyIds.has(property.PropertyID))
		.map((property) => `${property.Name} (${property.ShortName})`)
		.join(", ")
}
